export function reactTrackingEvent(data) {
  if (typeof window.trackEvent !== 'function') {
    return;
  }

  window.trackEvent(data.event, data);
}
